import { Directive, Input, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appRoleAddEdit]',
    standalone: false
})
export class RoleAddEditDirective implements OnInit {

  @Input('appRoleAddEdit') roles; // Accept roles as input
  list = "spc-ga,spc-gm,spc-reader,spc-sitekey,spc-factory-manager,spc-technical-admin,spc-factory-supervisor,spc-line-supervisor,spc-production-admin,spc-technical-operator,'spc-ca','spc-clusterdv','spc-countrydv','spc-deo','spc-sitedv'"; //these roles not have wrte access 
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const userRole = localStorage.getItem('userRole'); // Assuming you have a method to get the user role 
    if (this.list.includes(userRole)) {
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
      this.renderer.addClass(this.el.nativeElement, 'blurred');
    } else if (userRole === 'spc-key' && this.roles.action === 'edit') {
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
      this.renderer.addClass(this.el.nativeElement, 'blurred');
    } else if (userRole === 'spc-key' && this.roles.action === 'add') {
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'all');
      this.renderer.removeClass(this.el.nativeElement, 'blurred');
    }
  }
}
